<template>
    <div class="registersSuc">
        <div class="title">
            <svg slot="image" class="icon" aria-hidden="true">
                <!-- <use xlink:href="#icon-logo1"></use> -->
                <use xlink:href="#icon-daiwenzilogo"></use>
            </svg>
        </div>
        <div class="iconTitle">
            <div @click="$router.push('/register')">
                <img v-if="!this.isDirection" src="../assets/images/goleft.png">
                <img v-else src="../assets//images/goRight.png">
            </div>

            <div @click="$router.push('/newIndex')">
                <img :class="{ mirrorRotateLevel: isDirection }" src="../assets/images/close.png">
            </div>

        </div>
        <div class="content">
            <img src="../assets/images/uscIcon.png">
        </div>
        <!-- 注册成功 -->
        <div class="text">{{$t('9000030')}}</div>
        <div class="btns">
            <div class="downLoad" @click="$router.push('/download')">
                <!-- 下载APP -->
                {{$t('9000031')}}
            </div>
            <div class="goBack" @click="$router.push('/newIndex')">
                <!-- 返回首页 -->
                {{$t('9000032')}}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "registersSuc",
        components: {

        },
        data() {
            return {

            }
        },
        computed: {
            ...mapGetters(['isDirection'])
        },
        watch: {
        },
        created() {
            window.document.documentElement.setAttribute("dir", this.isDirection ? 'rtl' : 'ltr');
            console.log(this.isDirection, 'this.isDirection');
        },
        methods: {

        }
    }
</script>
<style lang="scss" scoped>
    [dir="ltr"] {
        .registersSuc .title .icon {
            margin-left: 1.2rem
        }
    }
    [dir="rtl"] {
        .registersSuc .title .icon {
            margin-right: 1.2rem
        }
    }
</style>
<style lang="scss" scoped>
    @import "../style/mixin";
    @import "../assets/css/variableName";

    body {
        background-color: #ffffff;
    }
    .registersSuc {
        background-color: #ffffff;
        height: 100vh;
        .title {
            display: flex;
            align-items: center;
            height: torem(41);
            .icon {
                width: torem(100);
                height: torem(20);
                margin-left: torem(24);
            }
        }
        .iconTitle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: torem(44);
            padding: 0 torem(28);
            img {
                width: torem(15);
                height: torem(15);
            }
            &-two {
                display: inline-block;
            }
        }
        .content {
            display: flex;
            justify-content: center;
            margin-top: torem(89);
        }
        .text {
            display: flex;
            justify-content: center;
            margin-top: torem(16);
            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
            font-weight: 500;
            font-size: torem(14);
            color: #000922;
            line-height: torem(16);
            text-align: left;
            font-style: normal;
            text-transform: none;
        }
        .btns {
            margin: 0 auto;
            padding: 0 torem(28);
            margin-top: torem(96);
            .downLoad {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: torem(44);
                background-color: #ffc72b;
                border-radius: 2px 2px 2px 2px;
                //font
                font-family: Lato, Lato;
                font-weight: 500;
                font-size: torem(16);
                color: #000922;
                line-height: torem(19);
                text-align: left;
                font-style: normal;
                text-transform: none;
            }
            .goBack {
                display: flex;
                justify-content: center;
                margin-top: torem(16);
                //font
                font-family: Lato, Lato;
                font-weight: 400;
                font-size: torem(12);
                color: #7f8490;
                line-height: torem(12);
                text-align: left;
                font-style: normal;
                text-transform: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/registersSuc.vue